import { Button } from "@/shared/ui/button";

interface Props { onConfirm: () => void; onBack: () => void }

export function MakeThisMineStep({ onConfirm, onBack }: Props): JSX.Element {
  return (
    <div className="flex min-h-[70vh] flex-col items-start justify-center gap-10" data-testid="make-this-mine-step">
      <div className="max-w-3xl space-y-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#c7a25a]">
          One decision
        </p>
        <h2
          className="font-serif text-4xl leading-[1.05] tracking-tight text-[#f5efe6] md:text-6xl"
          style={{ fontFamily: "'Fraunces', serif" }}
        >
          Now let's make it{" "}
          <span className="italic text-[#c7a25a]">your department</span>.
        </h2>
        <div className="max-w-xl space-y-4 text-[15px] leading-relaxed text-[#f5efe6]/80 md:text-[17px]">
          <p>
            The next few questions are conversational, not clinical.
            Intelly will listen — and shape everything you just saw
            into a Brand Brain, Business Brain, and first-month plan
            that actually sounds like your business.
          </p>
          <p className="text-[#f5efe6]/60">
            You can pause at any point. Nothing enters your workspace without your say-so.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3 md:flex-row md:items-center">
        <Button
          onClick={onConfirm}
          data-testid="make-this-mine-confirm"
          className="group h-14 rounded-full bg-[#c7a25a] px-10 text-[16px] font-medium text-[#0d1310] shadow-[0_24px_80px_-20px_rgba(199,162,90,0.6)] hover:bg-[#d4b06e]"
        >
          <span aria-hidden className="mr-2">✨</span>
          Yes, let's begin
        </Button>
        <button
          type="button"
          onClick={onBack}
          data-testid="make-this-mine-back"
          className="rounded-full border border-[#f5efe6]/12 px-6 py-3 text-[14px] text-[#f5efe6]/70 hover:text-[#f5efe6]"
        >
          Actually, I want to explore more
        </button>
      </div>
    </div>
  );
}
